import React from "react"
import { Col, Div, Row } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import PrimaryButton from "./PrimaryButton"
import SecondaryButton from "./SecondaryButton"
import { theme } from "../settings/config"

// I due tasti in fondo a un foglio che chiede conferma prima di eliminare o
// togliere qualcosa. Quello pieno, a destra sotto il pollice, lascia tutto
// com'è; quello che toglie sta a sinistra, senza fondo, rosso e col segno di
// quello che fa (il cestino, se non si dice altro): si vede subito quale dei
// due cancella, ed è il più difficile da prendere per sbaglio.
//
// `danger={false}` per un passo che ancora non toglie niente ("Avanti"):
// stessi posti, scritta scura e senza segno. Mentre lavora resta solo il
// tasto di sinistra, con la scritta di cosa sta facendo (`busyText`).
function ConfirmButtons({
	confirmText,
	onConfirm,
	cancelText = "No, macchè!",
	onCancel,
	icon = faTrashAlt,
	danger = true,
	busy = false,
	busyText,
	disabled = false,
}) {
	const text = busy && busyText ? busyText : confirmText
	return (
		<Div m={{ x: "1rem" }}>
			<Row m={{ t: "1rem" }}>
				<Col p="0">
					<SecondaryButton
						m="auto"
						textColor={danger ? theme.colors.red : theme.colors.gunmetal}
						textSize="subheader"
						textWeight={danger ? "600" : null}
						disabled={busy || disabled}
						action={() => !busy && !disabled && onConfirm()}
						text={
							danger ? (
								<span style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
									<FontAwesomeIcon icon={icon} />
									{text}
								</span>
							) : (
								text
							)
						}
					/>
				</Col>
				{!busy && (
					<Col p="0">
						<PrimaryButton
							m="auto"
							bg={theme.colors.gunmetal_fill}
							textColor="white"
							textSize="subheader"
							text={cancelText}
							action={onCancel}
						/>
					</Col>
				)}
			</Row>
		</Div>
	)
}

export default ConfirmButtons
